<template>
    <a href="/contact"
        class="fixed bottom-6 right-6 bg-red-500 text-white rounded-full shadow-lg w-14 h-14 flex items-center justify-center hover:bg-red-600 transition"
        title="Signaler un problème">
        <i class="fas fa-flag text-xl"></i>
    </a>
</template>